import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-links">
        <Link 
          to="/about" 
          className="footer-link"
        >
          About
        </Link>
        <span className="footer-sep">|</span>
        <Link 
          to="/contact" 
          className="footer-link"
        >
          Contact Us
        </Link>
        <span className="footer-sep">|</span>
        <Link 
          to="/terms" 
          className="footer-link"
        >
          Terms of Service
        </Link>
        <span className="footer-sep">|</span>
        <Link 
          to="/privacy" 
          className="footer-link"
        >
          Privacy Policy
        </Link>
        <span className="footer-sep">|</span>
        <Link 
          to="/cookies" 
          className="footer-link"
        >
          Cookies
        </Link>
      </div>
      <stripe-buy-button
        buy-button-id="buy_btn_1TNhUjLATflPODeHOj3Pv8SB"
        publishable-key="pk_live_51TNhBNLATflPODeHwyUpLaiXgxByaFgu4ozA4O5Rvs2ZaC0TNPa6rYKScXRysT5UqQYTVvZJNiIUoroPEUy5Cc4t00D6gUqsue"
      ></stripe-buy-button>
      <div className="footer-copy">
        © {currentYear} LOOWAY. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
